module.exports = __webpack_public_path__ + "fonts/NespressoLucas-Regular.eot?v=18cfe31479b2d5d4ff29a2011431538c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-Regular.eot?
// module id = 669
// module chunks = 0